import http from "./Http";

// COMPETENCIAS: /competencias/{idNivel}/{idArea}
const obtenerCompetencias = async (idNivel, idArea) => {
  const res = await http.get(`/competencias/${idNivel}/${idArea}`);
  return res.data.map(item => ({
    id: item.id,
    nombre: item.competencia
  }));
};

// CAPACIDADES: /capacidades/{idNivel}/{idArea}/{idCompetencia}
const obtenerCapacidades = async (idNivel, idArea, idCompetencia) => {
  const res = await http.get(`/capacidades/${idNivel}/${idArea}/${idCompetencia}`);
  return res.data.map(item => ({
    id: item.id,
    nombre: item.capacidad
  }));
};

// DESEMPEÑOS: (mantiene ruta anterior si tu backend lo usa)
const obtenerDesempeños = async (idNivel, idArea, idCompetencia, idGrado) => {
  const res = await http.get(`/desempenios/${idNivel}/${idArea}/${idCompetencia}/${idGrado}`);
  return res.data.map(item => ({
    id: item.id,
    nombre: item.desempenio
  }));
};

// ======================================================
// 🔹 OBTENER COMPETENCIA POR ID
//     /competencias/{comp_id}
// ======================================================
// Obtener una competencia por su ID
const obtenerCompetenciaPorId = async (compId) => {
  const res = await http.get(`/competencias/${compId}`);

  return {
    id: res.data.id,
    nombre: res.data.nombre,          // 🔥 CORREGIDO
    area_tematica_id: res.data.area_tematica_id
  };
};

// ======================================================
// 🔹 OBTENER CAPACIDAD POR ID
//     /capacidades/{cap_id}
// ======================================================
const obtenerCapacidadPorId = async (capId) => {
  const res = await http.get(`/capacidades/${capId}`);
  return {
    id: res.data.id,
    descripcion: res.data.descripcion
  };
};

// ======================================================
// 🔹 OBTENER DESEMPEÑO POR ID
//     /desempenios/{desempenio_id}
// ======================================================
const obtenerDesempenioPorId = async (desId) => {
  const res = await http.get(`/desempenios/${desId}`);
  return {
    id: res.data.id,
    descripcion: res.data.descripcion
  };
};

const CompetenciaService = {
  obtenerCompetencias,
  obtenerCapacidades,
  obtenerDesempeños,

  obtenerCompetenciaPorId,
  obtenerCapacidadPorId,
  obtenerDesempenioPorId
};

export default CompetenciaService;
